import React from 'react'
import { Col, Row } from 'reactstrap'

const PanelServices = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 pt-md-5 pt-4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    Services
                </div>
                <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='fs-ss-20-2 text-montserrat fw-600 text-ss-black lh-1-2 pb-2 pt-1' style={{ fontStyle:'italic'}}>
                <div className=''>
                    United Lab Care Offers
                </div>
            </div>

            <div className='py-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Are you looking for lab testing services in Chicago? We are one of the leading Lab Service Providers offering testing services in diverse areas of Chicago. All tests conducted in our lab are clean and organized under the high supervision of skilled and knowledgeable professionals. The atmosphere of the laboratories is regulated following the type of test performed. The services offered by United Lab Care are at par with the international quality standard. The following lab services that we offer our clients:
                </div>
            </div>

            {/* Desktop Size */}
            <div className='pt-md-5 pt-4 display-none'>
                <Row className='left-padding8rem1 right-padding8rem1'>
                    <Col md='6' lg='6'  className='bg-im' style={{ backgroundImage:"url('panel-testing/RSV-Testing-Service-bg1.png')",backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                        <div className='' style={{ padding:'2.5rem 3rem 3rem 2rem', cursor:'pointer'}}>
                            <div className='pb-lg-4 pb-md-1'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700'>
                                    RSV Testing
                                </div>
                            </div>

                            <div className=''>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                  United Care Lab provides efficient<br/> test solutions and a wide range of<br/> transparent, reliable, and quick<br/> RSV tests.
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col md='6' lg='6' className='bg-im widget1-width1' style={{ backgroundImage:"url('panel-testing/Influenza-Testing-Service-bg1.png')", backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                    <div className='' style={{ padding:'', cursor:'pointer'}}>
                            <div className='pb-4'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700'>
                                    Influenza Testing
                                </div>
                            </div>

                            <div className=''>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                Be safe & healthy and get<br/> convenient, quick, and reliable<br/> testing services before experiencing<br/> flu-like symptoms.
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='pt-md-5 display-none'>
                <Row className='left-padding8rem1 right-padding8rem1'>
                    <Col md='6' lg='6' className='bg-im' style={{ backgroundImage:"url('panel-testing/Respiratory-Panel-Testing-Service-bg1.png')", backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                    <div className='' style={{ padding:'2rem 3rem 3rem 2rem', cursor:'pointer'}}>
                            <div className='pb-xl-4 pb-lg-1 pb-md-1'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700' style={{ lineHeight:'1.3'}}>
                                Respiratory Pathogen<br/> Panel Testing
                                </div>
                            </div>

                            <div className=''>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                Get various tests for viruses and<br/> bacteria in the respiratory tract<br/> through Respiratory pathogen<br/> panel testing services in Chicago.
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col md='6' lg='6' className='bg-im widget1-width1' style={{ backgroundImage:"url('panel-testing/Covid-Testing-Service-bg1.png')", backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                    <div className='' style={{ padding:'', cursor:'pointer'}}>
                            <div className='pb-4'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700'>
                                    Covid-19 Testing
                                </div>
                            </div>

                            <div className='pt-3'>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                We offer accurate and efficient<br/> testing solutions for symptomatic<br/> and asymptomatic Covid-19 cases.
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* ------------------------ */}

            {/* Mobile Version */}
            {/* <div className='pt-md-5 pt-4 display-block1'>
                <Row className='left-padding8rem1 right-padding8rem1'>
                    <Col xs='6' md='6'   className='bg-im' style={{ backgroundImage:"url('panel-testing/RSV-Testing-Service-bg1.png')",backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                        <div className='' style={{ padding:'1.5rem 3rem 3rem 1rem', cursor:'pointer'}}>
                            <div className='pb-2'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700'>
                                    RSV Testing
                                </div>
                            </div>

                            <div className=''>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                  United Care Lab provides efficient<br/> test solutions and a wide range of<br/> transparent, reliable, and quick<br/> RSV tests.
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col xs='6' md='6'  className='bg-im' style={{ backgroundImage:"url('panel-testing/Influenza-Testing-Service-bg1.png')", backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                    <div className='' style={{ padding:'1.5rem 0rem 3rem 5.5rem', cursor:'pointer'}}>
                            <div className='pb-2'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700'>
                                    Influenza Testing
                                </div>
                            </div>

                            <div className=''>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                Be safe & healthy and get<br/> convenient, quick, and reliable<br/> testing services before experiencing<br/> flu-like symptoms.
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='pt-md-5 pt-3 display-block1 '>
                <Row className='left-padding8rem1 right-padding8rem1'>
                    <Col xs='6' md='6'  className='bg-im' style={{ backgroundImage:"url('panel-testing/Respiratory-Panel-Testing-Service-bg1.png')", backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                    <div className='' style={{ padding:'1.2rem 3rem 3rem 1rem', cursor:'pointer'}}>
                            <div className='pb-2'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700' style={{ lineHeight:'1.3'}}>
                                Respiratory Pathogen<br/> Panel Testing
                                </div>
                            </div>

                            <div className=''>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                Get various tests for viruses and<br/> bacteria in the respiratory tract<br/> through Respiratory pathogen<br/> panel testing services in Chicago.
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col xs='6' sm='' md='6'  className='bg-im' style={{ backgroundImage:"url('panel-testing/Covid-Testing-Service-bg1.png')", backgroundSize:'contain',backgroundRepeat:'no-repeat', height:'auto', width:''}}>
                    <div className='' style={{ padding:'1.5rem 0rem 3rem 5.5rem', cursor:'pointer'}}>
                            <div className='pb-2'>
                                <div className='fs-ss-20 text-ss-secondary text-montserrat fw-700'>
                                    Covid-19 Testing
                                </div>
                            </div>

                            <div className='pt-'>
                                <div className='fs-ss-14 text-montserrat fw-600 text-ss-black'>
                                We offer accurate and efficient<br/> testing solutions for symptomatic<br/> and asymptomatic Covid-19 cases.
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div> */}

            <div className='d-flex justify-content-center my-4'>
            <div className='left-padding8rem1 right-padding8rem1 display-block1'>
                <div className='rounded30 px-3 ps-4 py-2 widget-width' style={{ border:'2px dashed #EB242B', backgroundColor:'#f8f8f8',boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', width:''}}>
                    <div className='d-flex justify-content-end'>
                        <img src='/panel-testing/RSV-Test-icon.png' alt='rsv' width='70px'  />
                    </div>
                    <div className='pb-2' style={{ marginTop:'-16px'}}>
                            <text className='fs-ss-18-1 text-montserrat fw-700 text-ss-secondary'>
                                RSV Testing
                            </text>
                    </div>
                    <div className='pb-2'>
                        <text className='fs-ss-14-1 text-montserrat fw-600'>
                        United Care Lab provides efficient test solutions and a wide range of transparent, reliable, and quick RSV tests.
                        </text>
                    </div>
                </div>
                </div>
            </div>
           
           
            <div className='d-flex justify-content-center my-4'>
            <div className='left-padding8rem1 right-padding8rem1 my-3 display-block1'>
                <div className='rounded30 px-3 ps-4 py-2 widget-width' style={{ border:'2px dashed #EB242B', backgroundColor:'#f8f8f8',boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', width:''}}>
                    <div className='d-flex justify-content-end'>
                        <img src='/panel-testing/Flu-Test-icon.png' alt='rsv' width='70px'  />
                    </div>
                    <div className='pb-2' style={{ marginTop:'-16px'}}>
                            <text className='fs-ss-18-1 text-montserrat fw-700 text-ss-secondary'>
                                Influenza Testing
                            </text>
                    </div>
                    <div className='pb-2'>
                        <text className='fs-ss-14-1 text-montserrat fw-600'>
                        Be safe & healthy and get convenient, quick, and reliable testing services before experiencing flu-like symptoms.
                        </text>
                    </div>
                </div>
                </div>
            </div>
            
            
            <div className='d-flex justify-content-center my-4'>
            <div className='left-padding8rem1 right-padding8rem1 display-block1'>
                <div className='rounded30 px-3 ps-4 py-2 widget-width' style={{ border:'2px dashed #EB242B', backgroundColor:'#f8f8f8',boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', width:''}}>
                    <div className='d-flex justify-content-end'>
                        <img src='/panel-testing/Repiratory-Pathogen-Panel-test-icon.png' alt='rsv' width='70px'  />
                    </div>
                    <div className='pb-2' style={{ marginTop:'-16px'}}>
                            <text className='fs-ss-18-1 text-montserrat fw-700 text-ss-secondary'>
                            Respiratory Pathogen Panel<br/> Testing
                            </text>
                    </div>
                    <div className='pb-2'>
                        <text className='fs-ss-14-1 text-montserrat fw-600'>
                        Get various tests for viruses and bacteria in the respiratory tract through Respiratory pathogen panel testing services in Chicago.
                        </text>
                    </div>
                </div>
                </div>
            </div>
            
            
            <div className='d-flex justify-content-center my-4'>
            <div className='left-padding8rem1 right-padding8rem1 my-3 mb-md-0 display-block1'>
                <div className='rounded30 px-3 ps-4 py-2 widget-width' style={{ border:'2px dashed #EB242B', backgroundColor:'#f8f8f8',boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', width:''}}>
                    <div className='d-flex justify-content-end'>
                        <img src='/panel-testing/RT-PCR-Test-icon.png' alt='rsv' width='70px'  />
                    </div>
                    <div className='pb-2' style={{ marginTop:'-16px'}}>
                            <text className='fs-ss-18-1 text-montserrat fw-700 text-ss-secondary'>
                            Covid-19 Testing
                            </text>
                    </div>
                    <div className='pb-2 pe-3'>
                        <text className='fs-ss-14-1 text-montserrat fw-600'>
                        We offer accurate and efficient testing solutions for symptomatic and asymptomatic Covid-19 cases.
                        </text>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PanelServices